import { Navigate } from 'react-router-dom';

function DistributorProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  try {
    const user = JSON.parse(atob(token));
    if (user?.type === 'distributor') return children;
  } catch {}
  return <Navigate to="/distributor-login" />;
}
export default DistributorProtectedRoute;
